import { Group, MantineTheme } from "@mantine/core";
import { IconAlertHexagonFilled } from "@tabler/icons-react";
import { ReactNode } from "react";


export function ClientesTiendasProductosOverrides(theme: MantineTheme) {
    //Overrides para alertas
    return {
        4: { render: (value: unknown) => (!value) ? <Group><IconAlertHexagonFilled style={{ color: theme.colors.red[8] }} size="1.3rem" />Sin servicios</Group> : value as ReactNode },
    }
}
